<!-- footer start-->
<div class="container-fluid">

  <ng-container *ngIf="footer.icon_whatsapp.active">
    <div id="wasaprow" class="row">
      <!-- <a href="https://api.whatsapp.com/send?phone=+5493584701936"><img src="./assets/images/logo/logo-WA.png"></a> -->
      <a href="{{footer.icon_whatsapp.link}}" target="_blank"><img src="./assets/images/logo/logo-WA.png"></a>
    </div>
  </ng-container>

  <div class="text-center">
    <div class="row">
      <ng-container *ngIf="footer.footer">

        <!-- SC CATFER-3 Se agregan las imagenes para el footer del cliente -->
        <div class="col-md-4">
          <div class="col-12" style="margin-top: 40px;">
            <img src="./assets/images/logo/logo_dark.png" alt="Logo">
          </div>
          <div class="col-12" style="margin-top: 40px;">
            <img src="./assets/images/logo/logo-copmaco-dark.png" alt="">
          </div>
        </div>
        <!-- <ng-container *ngFor="let item of footer.items; let i=index">
          <div class="col-md-3 font-footer text-left m-t-40">
            <h6>{{item.tittle}}</h6>
            <ul>
              <li *ngFor="let info of item.info; let i=index" class="submenu-title ng-star-inserted">
                <ng-container *ngIf="info.link!=''; else elseText">
                  <a href="{{info.link}}" target="_blank"><i class="{{info.icon}}"></i> {{info.descripcion}}</a>
                </ng-container>
                <ng-template #elseText>
                  <span><i class="{{info.icon}}"></i> {{info.descripcion}}</span>
                </ng-template>
              </li>
            </ul>
          </div>
        </ng-container> -->

        <!-- MC CATFER-90 Se manejan cada una de las secciones individualmente porque tienen anchos distintos -->
        <div class="col-md-2 font-footer text-left m-t-40">
          <ng-container *ngFor="let item of FERRETTI_1">
            <h6>{{ item.title }}</h6>
            <ul>
              <li *ngFor="let info of item.info"
              class="submenu-title ng-star-inserted">
                <a href="{{info.link}}" target="_blank"><i class="{{info.icon}}"></i> {{info.descripcion}}</a>
            </li>
          </ul>
          </ng-container>
        </div>

        <div class="col-md-2 font-footer text-left m-t-40">
          <ng-container *ngFor="let item of FERRETTI_2">
            <ul class="mb-4">
              <li *ngFor="let info of item.info"
              class="submenu-title ng-star-inserted">
                <a href="{{info.link}}" target="_blank"><i class="{{info.icon}}"></i> {{info.descripcion}}</a>
              </li>
            </ul>
          </ng-container>
        </div>

        <div class="col-md-4 font-footer text-left m-t-40">
          <ng-container *ngFor="let item of FERRETTI_3">
            <h6>{{ item.title }}</h6>
            <ul class="mb-4">
              <li *ngFor="let info of item.info"
              class="submenu-title ng-star-inserted">
                <span><i class="{{info.icon}}"></i> {{info.descripcion}}</span>
              </li>
            </ul>
          </ng-container>
        </div>

      </ng-container>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Copyright © 2019-{{ today | date:'y'}} <a href="https://www.oliverinformatica.com/"
          target="_blank"> Oliver</a> - Versión: {{version}}</p>
    </div>
  </div>
</div>